import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formLayout: {
      // marginLeft: "auto",
      // marginRight: "auto",
      // maxWidth: 1000,
    },
    formWrapper: {
      maxWidth: 1000,
      width: "100%",
    },
    form: {
      padding: theme.spacing(4),
    },
  })
);
